<div class="notifier-container">
    <button class="close" mat-icon-button (click)="snackBarRef.dismiss()">
        <mat-icon class="ltr:-ml-2 rtl:-mr-2 ltr:mr-2 rtl:ml-2"
        >close</mat-icon>
    </button>
    <div class="header">{{data.type}}</div>
    <div class="content" [innerHTML]="data.message"></div>
</div>